<template>
  <div class="dn-report">
    <ReportsHomeV2 title="Delivery Note Report" placeholder="DN No" :inputValue="dnno" @generateReport="generateReport" @shareReport="shareReport"
      ref="report" :shareContent="reportShareDetails" >

    </ReportsHomeV2>

    <Loader :isVisible="loading" :loadingText="loadingText" :isFullScreen="true" />
  </div>
</template>

<script>
/* eslint-disable */
import ReportsHomeV2 from '@/pages/ReportsV2/ReportsHome';

export default {
  components: {
    ReportsHomeV2
  },
  data: function() {
    return {
      loading: false,
      loadingText: '',

      dnno: '',
      userid: '',
      configCode: '',

      user: '',

      reportShareDetails: {}
    }
  },
  props: {
  },
  methods: {
    generateReport: async function() {
      this.loading = true;

      this.loadingText = 'Getting Details';
      let dnDetails = [];

      var loginDetails = await this.$apiCallV2('/Login/GetDetails');

      if (this.user) {
        dnDetails = await this.$apiCallV2(`/DeliveryNotes/GetDeliveryNoteDetails?dnno=${this.dnno}`);
      } else {
        dnDetails = await this.$apiCallV2(`/DeliveryNotes/GetDeliveryNoteDetails?dnno=${this.dnno}&config=${this.configCode}&userid=${this.userid}`)
      }

      if (dnDetails.length == 0) {
        this.$showAlert('error', 'Invalid Delivery Note #', `Please verify your DN # ${this.dnno} is correct`);
      } else {
        let data = dnDetails[0];
        if (data['ROTDate']) {
          data['ROTDate'] = new Date(data['ROTDate']).formatString(this.$store.state['preferredDateFormat']);
        }
        if (data['Date_ETA']) {
          data['Date_ETA'] = new Date(data['Date_ETA']).formatString(this.$store.state['preferredDateFormat']);
        }

        data['companyHeader'] = loginDetails.CoHeaderOpr ? loginDetails.CoHeaderOpr : '';
        data['companyName'] = loginDetails.CoName ? loginDetails.CoName : '';
        this.$refs['report'].generateReport('BJl6F_jNVD', data);
      }
      
      this.loading = false;
    },
    shareReport: async function() {
      let folder = '';

      if (this.user) {
        let details = await this.$apiCallV2('/Login/GetDetails');
        folder = `DN,${details['ConfigCode']}`;
      } else {
        folder = `DN,${this.configCode}`; 
      }

      this.$refs['report'].generateShareLink(`DN-${this.dnno.split('/').join('_')}`, `DN,${folder}`);
    },
  },
  mounted() {
    let query = this.$route.query;
    let params = this.$route.params;

    if (query['dn']) {
      this.dnno = query['dn'];
    }
    if (query['userid']) {
      this.userid = query['userid'];
    }
    if (query['config']) {
      this.configCode = query['config'];
    }

    if (params['user']) {
      this.user = params['user'];
    }

    this.reportShareDetails['subject'] = `Delivery Note Report - ${this.dnno}`;
    this.reportShareDetails['body'] = `Your Delivery Note Report for Delivery Note # ${this.dnno} is available at {link}`;

    if (this.dnno) {
      this.generateReport();
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.dn-report {
  height: 100%;
  width: 100%;
}
</style>